import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { breakpoint } from '@twistopayments/design-system/styles'
import type { ResponsiveFieldStyle } from '@twistopayments/design-system/theme'

export const responsiveFieldStyle = ({ base, desktop }: ResponsiveFieldStyle) => css`
  ${base}
  ${breakpoint.up('md')} { ${desktop} }
`

// PhoneNumberField places these frames side by side: keep their box models identical.
export const fieldRoot = (theme: Theme) => css`
  width: 100%;
  display: flex;
  align-items: center;
  ${responsiveFieldStyle(theme.presentation.field.frame)}
`

export const fieldFocused = (theme: Theme) => css(theme.presentation.field.focused)
export const fieldError = (theme: Theme) => css(theme.presentation.field.error)
